import { getMessages } from '../../../../../../store/constants';

export const SHARE_HINT_TEXT = getMessages().getText('share_dialog_hint_text');
export const SHARE_HINT_BUTTON = getMessages().getText('share_dialog_hint_button_dont_show');
export const SHARE_HINT_CLOSE = getMessages().getText('common.close');
